export default function ComparisonTestimonial({
  quote,
  authorInitials,
  authorName,
  authorRole,
}) {
  return (
    <section className="bg-blue-primary-900 text-white py-20 px-6 lg:px-10 text-center">
      <div className="max-w-[700px] mx-auto fade-in">
        {/* Quote icon */}
        <div className="text-[40px] text-white/15 mb-5 leading-none">&ldquo;</div>

        {/* Quote */}
        <p
          className="font-inter text-xl font-normal leading-[1.6] mb-6 italic text-white/90"
          dangerouslySetInnerHTML={{ __html: quote }}
        />

        {/* Author */}
        <div className="flex items-center justify-center gap-3">
          {authorInitials && (
            <div className="w-12 h-12 rounded-full bg-white/10 flex items-center justify-center font-bold text-base text-white/60">
              {authorInitials}
            </div>
          )}
          <div className="text-left">
            <div className="font-inter font-bold text-[15px]">{authorName}</div>
            <div className="font-inter text-[13px] text-white/50">
              {authorRole}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
